import React, { useRef, useState } from 'react';
//import { useCelebrityHomeAPI } from '../../hooks/useAllCategoryData';
import { useNewHomeAPI } from '../../hooks/useAllCategoryData';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import parse from "html-react-parser";
import ShimmerSingleBox from '../ShimmerSingleBox';

const ShopByCategory = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("shopByCollection");
  const videoRef = useRef(null); // Reference to the video element
  const carouselRef = useRef(null);

  const handleVideoSelect = (e) => {
    setSelectedVideo(e);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    if (videoRef.current) {
      videoRef.current.pause(); // Stop the video when modal closes
      videoRef.current.currentTime = 0; // Reset to the beginning
    }
  };
  const { isLoading, error, data } = useNewHomeAPI();
  if (error) return <div>{error.message}</div>;

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 1, // optional, default to 1.
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
      slidesToSlide: 1, // optional, default to 1.
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
      slidesToSlide: 1, // optional, default to 1.
    },
  };

  const selectedData =
  data?.shopByCategory?.find(
    (category) => category.type === selectedCategory
  ) || {};



  //console.log(data?.celebrity)
  return (
    <>

      <div className='shopByCategory'>
        <div className='container'>
          <h2>Shop By Category</h2>

          {isLoading && (<div className="products home-banner-shimmer">
            {Array.from({ length: 1 }, (_, index) => (
              <ShimmerSingleBox key={index} CustomStyle={{ height: "1510px" }} />
            ))}
          </div>)}


          {data?.shopByCategory && (
            <select
              className="shopByCategory"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              {data?.shopByCategory?.map((category) => (
                <option key={category.type} value={category.type}>
                  {category.lable}
                </option>
              ))}
            </select>
          )}







          {data?.shopByCategory && (
            <div class="category-full">
              <Carousel
               key={selectedCategory}
                showDots={false}
                responsive={responsive}
                ssr={true} // means to render carousel on server-side.
                infinite={true}
                //autoPlay={this.props.deviceType !== "mobile" ? true : false}
                autoPlaySpeed={1000}
                //keyBoardControl={true}
                //customTransition="all .5"
                transitionDuration={500}
                containerClass="carousel-container"
                //removeArrowOnDeviceType={["tablet", "mobile"]}
                //deviceType={this.props.deviceType}
                dotListClass="custom-dot-list-style"
                itemClass="carousel-item-padding-30-px"
                arrows={false} // Hide default arrows
                ref={carouselRef}
              >
                {selectedData?.items?.map((e, i) => (
  <div key={i}>
    <div className="img-box">
      <a href={e.url}>
        <img
          src={`${process.env.REACT_APP_IMAGE_URL}/home/category-img/${e.thumbnail}`}
          alt={e.title}
        />
      </a>
    </div>

    <h2>
      <a href={e.url} className="newfont-heading">
        {e.title}
      </a>
    </h2>

    {/* <p>{e.text && parse(e.text)}</p>

    {e.videopop && (
      <div className="viewvideobtn">
        <span onClick={() => handleVideoSelect(e)}>
          {e.videopop}
        </span>
      </div>
    )}

    <div className="viewmorebtn">
      <a href={e.url}>EXPLORE</a>
    </div>
    
    */}
  </div>
))}
              </Carousel>
              <div className="flex gap-2">
                <button className='left-arrow' onClick={() => carouselRef.current.previous()}> </button>
                <button className='right-arrow' onClick={() => carouselRef.current.next()}> </button>
              </div>
            </div>

          )}




        </div>
        {isModalOpen && (
          <div className="video-modal">
            <div className="video-overlay"><span className="close" onClick={closeModal}></span></div>
            <div className="video-modal-content">
              <span className="close mobile-video-close" onClick={closeModal}></span>
              {selectedVideo && (
                <video ref={videoRef} width="528" height="937" controls autoPlay playsInline webkitPlaysInline preload="auto">
                  <source src={`${process.env.REACT_APP_IMAGE_URL}/home/category-img/${selectedVideo.src}`} type="video/mp4" />
                </video>
              )}
            </div>
          </div>
        )}
      </div>

    </>
  )
}
export default ShopByCategory 